export default __webpack_public_path__ + "static/media/i_bus-noti_active.671878f5.svg";